/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/26/19
 * Time: 3:44 PM
 */
import * as actionTypes from '../Action/actionTypes';

const initialState = {
  user: {},
  tagsDashboard: {

  }
};

const reducer=(state=initialState,action)=>{
  switch(action.type){


    case actionTypes.USER:
      return {
        ...state,
        user: action.value
      };

    default:
      return state;
  }
};

export default reducer;
